export function createSlug(input?: string) {
	return input
		? input
				.toLowerCase()
				.replace(/ /g, "-")
				.replace(/[^a-z0-9-]/g, "")
				.replace(/--+/g, "-")
				.replace(/^-+|-+$/g, "")
		: ""
}
